import React, { useEffect, useState } from 'react';
import { Loader } from '@mantine/core';
import { ordersService, type OrderView } from '../../../../services/orders/orders.service';
import { OrdersTable } from '../orders/table/OrdersTable';
import classes from './pos-table-history-section.module.scss';

type Props = {
  tenantId: string;
  employeeSession: string;
  tableId: number;
  tableLabel: string;
  onSelectOrder?: (order: OrderView) => void;
};

// Inline table-history: reuses OrdersTable for paid/closed orders; row → restore bill.
const PosTableHistorySectionComponent: React.FC<Props> = ({ tenantId, employeeSession, tableId, tableLabel, onSelectOrder }) => {
  const [orders, setOrders] = useState<OrderView[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);
    ordersService
      .listTableHistory(tenantId, tableId, employeeSession)
      .then((result) => {
        if (active) setOrders(result);
      })
      .catch((loadError: unknown) => {
        if (active) setError(loadError instanceof Error ? loadError.message : 'טעינת היסטוריית השולחן נכשלה');
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [tenantId, tableId, employeeSession]);

  return (
    <section className={classes.screen} data-testid="table-history-section">
      <h2 className={classes.title}>{`היסטוריית שולחן ${tableLabel}`}</h2>

      {isLoading && (
        <div className={classes.loadingWrap}>
          <Loader />
        </div>
      )}
      {!isLoading && error && <p className={classes.error}>{error}</p>}
      {!isLoading && !error && (
        <OrdersTable
          orders={orders}
          selectedOrderId={null}
          onSelectOrder={(order) => onSelectOrder?.(order)}
          hideTypeFilter
          searchPlaceholder="חיפוש לפי מלצר או שם לקוח"
          emptyMessage="לא קיימת היסטוריית הזמנות עבור שולחן זה"
        />
      )}
    </section>
  );
};

export const PosTableHistorySection = React.memo(PosTableHistorySectionComponent);
